// GENERATED from analysis/number-ones/tier1_digit1_reference.json — do not hand-edit.
// Regenerate: python3 analysis/number-ones/build_singlesingle_evidence.py
//
// Tier I (single-letter Number Ones) register reference. Evidence: UK
// Single-Single Number Plate Registry (singlesingle.co.uk, retrieved
// 2026-07-18) reconciled against PlateX live + sold data. Attributed external
// evidence, NOT DVLA-verified — full provenance per record in the JSON.
//
// Public-state mapping (Gate 2 data-meaning pass):
//   held      — holding state evidenced (retention / assigned to a vehicle)
//   existing  — credible evidence of survival only; holding state not asserted
//   lost      — positively supported as lost
//   never-issued — series structure (letters I and Q never issued)
// Live listings override to 'available' at runtime.

export type Tier1RefState = 'held' | 'existing' | 'lost' | 'never-issued' | 'unconfirmed';

export const TIER1_REFERENCE: { [combo: string]: Tier1RefState } = {
  '1 A': 'existing',
  'A 1': 'held',
  '1 B': 'existing',
  'B 1': 'existing',
  '1 C': 'existing',
  'C 1': 'existing',
  '1 D': 'existing',
  'D 1': 'existing',
  '1 E': 'existing',  // live-listed 2026-07-18; baseline existing
  'E 1': 'existing',
  '1 F': 'existing',
  'F 1': 'existing',  // live-listed 2026-07-18; baseline existing
  '1 G': 'existing',
  'G 1': 'existing',
  '1 H': 'existing',
  'H 1': 'existing',
  '1 I': 'never-issued',
  'I 1': 'never-issued',
  '1 J': 'held',
  'J 1': 'lost',
  '1 K': 'existing',
  'K 1': 'existing',
  '1 L': 'existing',
  'L 1': 'existing',
  '1 M': 'held',
  'M 1': 'existing',
  '1 N': 'existing',
  'N 1': 'existing',
  '1 O': 'held',
  'O 1': 'existing',
  '1 P': 'existing',
  'P 1': 'existing',
  '1 Q': 'never-issued',
  'Q 1': 'never-issued',
  '1 R': 'existing',
  'R 1': 'held',
  '1 S': 'existing',
  'S 1': 'existing',
  '1 T': 'existing',
  'T 1': 'held',
  '1 U': 'existing',
  'U 1': 'held',
  '1 V': 'existing',
  'V 1': 'held',
  '1 W': 'existing',
  'W 1': 'existing',
  '1 X': 'held',
  'X 1': 'existing',
  '1 Y': 'existing',
  'Y 1': 'held',
  '1 Z': 'existing',
  'Z 1': 'existing',
};
